import { createFileRoute } from "@tanstack/react-router"
import type { Role } from "@nova-ai/shared"

import { AppShell } from "../components/layout/app-shell"
import { QueryState } from "../components/layout/query-state"
import { StatusText } from "../components/ui/status-text"
import { UsersTable } from "../components/users/users-table"
import { useSetUserRole, useUsers } from "../services/use-users"

function UsersPage() {
  const { data, isLoading, error } = useUsers()
  const setRole = useSetUserRole()

  const handleRoleChange = (id: number, role: Role) => {
    setRole.mutate({ id, role })
  }

  return (
    <AppShell title="Users" description="Manage dashboard access and operator roles.">
      <QueryState isLoading={isLoading} error={error}>
        <UsersTable
          users={data ?? []}
          isUpdating={setRole.isPending}
          onRoleChange={handleRoleChange}
        />
      </QueryState>

      {setRole.isError && (
        <StatusText variant="error" className="mt-3">
          Failed: {setRole.error.message}
        </StatusText>
      )}
    </AppShell>
  )
}

export const Route = createFileRoute("/users")({
  component: UsersPage,
})
